export const MIN_FILTER_WIDTH = '200px';
